import { Chip, Typography, type ChipProps } from "@mui/material";
import React from "react";

export function ReceivableTag(props: ChipProps) {
  const { sx, ...restProps } = props;
  return (
    <Chip
      label={<Typography fontSize={12}>Receivable</Typography>}
      color="primary"
      size="small"
      sx={{
        height: "unset",
        borderRadius: "4px",
        "& > .MuiChip-label": { paddingLeft: "4px", paddingRight: "4px" },
        ...sx,
      }}
      {...restProps}
    />
  );
}
